import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/requests'

export default {

  async list (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/list', criterias, { headers: headers })
  },

  async detail (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/detail', criterias, { headers: headers })
  },

  async cancel (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/cancel', criterias, { headers: headers })
  },

  async updatedParams (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/updatedParams', criterias, { headers: headers })
  },

  async paramsDiff (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/paramsDiff', criterias, { headers: headers })
  },

  async requestParams (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/requestParams', criterias, { headers: headers })
  },
}
